import React, {useEffect, useState} from 'react'
import {Divider, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import ConditionElement from './ConditionElement';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import AddButton from 'components/button/AddButton';
import NewCondition from 'components/popup/newCondition/NewCondition';
import getObjectValue from 'libs/getObjectValue';
import {CONDITIONS_LABEL, CONDITIONS_LABEL_PZP_2021, CONDITION_TYPE_OTHER} from 'components/popup/newCondition/constants/condition.values';
import Checkbox from 'components/Checkbox';
import {withRouter} from "react-router";
import ConfirmDeleteCriterion from "./ConfirmDeleteCriterion";
import {addElementsToParts, removeElementsfromParts} from "../lib/manipulateElementsOnParts";
import {getDemandPZPType} from "libs/getDemandStatus";
import PZPType from "constants/PZPType";
import _ from 'lodash';

const style = theme => ({
    root: {
        width: '100%',
        '&>*': {
            width: 'inherit'
        }
    },
    header: {
        marginTop: theme.spacing(1),
        fontWeight: theme.typography.fontWeightBold,
    },
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    }
})

function ConditionsSection(
    {
        classes,
        formikProps,
        rootId,
        id,
        checkboxId,
        match,
        partId,
        stageId,
        dirtyListenerSemaphore
    }) {
    const [openPopup, setOpenPopup] = useState(false);
    const [openDeletePopup, setOpenDeletePopup] = useState(false);
    const [editElement, setEditElement] = useState();

    const demandId = match.params.id;

    const thisId = id;

    const editable = getObjectValue('_editable', formikProps.values, true);
    const elements = getObjectValue(thisId, formikProps.values, []);

    const demandPzpType = getDemandPZPType();
    const conditionLabels = PZPType.PZP_2021 === demandPzpType ? CONDITIONS_LABEL_PZP_2021 : CONDITIONS_LABEL;

    const handleAddCondition = ({parts, ...values}) => {
        addElementsToParts(formikProps, id, parts, values, editElement, demandId)
        setOpenPopup(false)
        setEditElement()
    }

    const handleEdit = (index) => {
        setEditElement(_.cloneDeep(elements[index]));
        setOpenPopup(true);
    }

    const onClosePopup = () => {
        setOpenPopup(false)
        setEditElement()
    }

    const conditionsInSiwz = getObjectValue(checkboxId, formikProps.values);


    const handleDeleteButtonPress = (index) => {
        setEditElement(_.cloneDeep(elements[index]));
        setOpenDeletePopup(true);
    }

    const onCloseDeletePopup = () => {
        setOpenDeletePopup(false)
        setEditElement();
    }

    const handleDeleteCondition = ({parts}) => {
        removeElementsfromParts(formikProps, id, parts, editElement, demandId);
        setOpenDeletePopup(false);
        setEditElement();
    }


    useEffect(() => {
        dirtyListenerSemaphore.current = true;
        if (elements.length > 0) {
            formikProps.setFieldValue(checkboxId, false)
        } else if (elements.length === 0 && !conditionsInSiwz) {
            formikProps.setFieldValue(checkboxId, true)
        }
        dirtyListenerSemaphore.current = false;
        // eslint-disable-next-line
    }, [elements.length])

    return (
        <>
            <GridBlock
                className={classes.root}
                direction='column'
            >
                <Typography
                    variant='body1'
                    className={classes.header}
                >
                    {Tr('conditions')}
                    {!conditionsInSiwz ?
                        ` (${elements.length})`
                        : ''
                    }

                </Typography>

                <Checkbox
                    label={Tr('conditions_specifed_in_SIWZ')}
                    formikProps={formikProps}
                    id={checkboxId}
                    disabled={!editable}
                />
                <GridBlock alignItems='center'>
                    {!conditionsInSiwz &&
                    elements.map((item, i) => {
                        const name = item.type === CONDITION_TYPE_OTHER ? item.otherName : conditionLabels[item.type];
                        return (
                            <ConditionElement
                                id={thisId}
                                index={i}
                                formikProps={formikProps}
                                name={name}
                                key={i}
                                onDelete={handleDeleteButtonPress}
                                onEdit={() => handleEdit(i)}
                                disabled={!editable}
                            />
                        )
                    })
                    }

                    <AddButton
                        onClick={() => setOpenPopup(true)}
                        disabled={!editable}
                    >
                        {Tr('add_condition')}
                    </AddButton>
                </GridBlock>
                <Divider className={classes.divider}/>
            </GridBlock>
            {openPopup && <NewCondition
                onAdd={handleAddCondition}
                onClose={() => onClosePopup()}
                partId={partId}
                initValues={editElement}
                elementList={formikProps.values.form}
                selectedItems={elements}
                demandId={demandId}
                stageId={stageId}
                showParts={editable}
            />}
            {openDeletePopup && <ConfirmDeleteCriterion
                onClose={() => onCloseDeletePopup()}
                onDelete={handleDeleteCondition}
                partId={partId}
                demandId={demandId}
                stageId={stageId}
                initCrit={editElement}
                allItems={formikProps.values.form}
                id={id}
            />}


        </>
    )
}

ConditionsSection.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(withRouter(ConditionsSection));